import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getPondTypesData(context) {
      const response = await Vue.axios.get(`${URL_API}pondtype`);
      let data = response["data"];
      context.commit("updatePondTypesData", data);
    },
    async createPondTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}pondtype/store`, body, config);
      context.dispatch("getPondTypesData");
    },
    async pushPondTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}pondtype/update`, body, config);
      context.dispatch("getPondTypesData");
    },
    async destroyPondTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}pondtype/destroy`, body, config);
      context.dispatch("getPondTypesData");
    }
  },
  mutations: {
    updatePondTypesData(state, pondTypesData) {
      state.pondTypesData = pondTypesData;
    }
  },
  state: {
    pondTypesData: []
  },
  getters: {
    allPondTypesData(state) {
      return state.pondTypesData;
    }
  }
};
